export enum NOTIFICATION_TYPE {
  SYSTEM = "system",
  SERVER_EVENT = "server_event",
  COMPANY = "company",
  OWNER = "owner",
  PLAN = "plan",
  CONFIGURATION = "configuration",
  SUPPORT = "support",
  FILE_ARCHIVE = 'file_archive',
}
